import React, { useEffect, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { VideoArticle } from '../server/libs/videoArticles';
import { MdHistory } from './Icons';
import LinkifyText from './LinkifyText';

export type VideoPlayerContentProps = VideoArticle & {
  videoUrl: string;
  poster: string;
  onPlay: () => void;
  descriptionLabel?: string;
  highlightLabel?: string;
  videoOnly?: boolean; // trueの場合動画以外の情報を非表示
};

function VideoPlayerContent({
  videoId,
  videoUrl,
  onPlay,
  poster,
  name,
  author,
  organization,
  description,
  highlight,
  descriptionLabel,
  highlightLabel,
  updateDate,
  videoOnly,
}: VideoPlayerContentProps) {
  const videoRef: {
    current: HTMLVideoElement | null;
  } = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.currentTime = 0;
      video.src = videoUrl;
      video.poster = poster;
    }
  }, [poster, videoUrl]);

  return (
    <Box>
      <video
        ref={videoRef}
        width="100%"
        controls
        controlsList="nodownload"
        onContextMenu={(e) => e.preventDefault()}
        onPlay={onPlay}
      />
      {!videoOnly && (
        <>
          <Box fontWeight="bold" fontSize="2xl" py={2} lineHeight={1.25}>
            {name}
          </Box>
          <Box fontSize="sm" pb={3} whiteSpace="pre-wrap">
            {!!organization && <Box>{organization}</Box>}
            <Box>{author}</Box>
          </Box>
          <Flex pb={4} gap={0.5}>
            <MdHistory color="#999999" size="1.1em" />
            <Text as="span" fontSize="xs">
              <time dateTime={updateDate.replaceAll('/', '-')}>
                {updateDate}
              </time>
            </Text>
          </Flex>
          <Flex
            flexDirection="column"
            fontSize="sm"
            bgColor="#F5F5F5"
            borderRadius={8}
            p={4}
            gap={4}
          >
            {!!description && (
              <Box whiteSpace="pre-wrap">
                {!!descriptionLabel && (
                  <Text fontWeight="bold">{descriptionLabel}</Text>
                )}
                <LinkifyText gaEventLabelPrefix={'special-video-description'}>
                  {description}
                </LinkifyText>
              </Box>
            )}
            {!!highlight && (
              <Box whiteSpace="pre-wrap">
                {!!highlightLabel && (
                  <Text fontWeight="bold">{highlightLabel}</Text>
                )}
                <LinkifyText gaEventLabelPrefix={'special-video-highlight'}>
                  {highlight}
                </LinkifyText>
              </Box>
            )}
          </Flex>
        </>
      )}
    </Box>
  );
}

export default VideoPlayerContent;
